<template>
  <v-container grid-list-xl class="pa-0">
    <m-card-list
      two-line
      title="Daftar Riwayat Akses"
      label-cari="Cari Log"
      search
      :items="items"
      :headers="headers"
      refresh
      @refresh="load"
      :page="page"
      footer
      @search="
            (search) => {
              textSearch = search
              load()
            }
          "
      @change:page="
            (pg) => {
              cp = pg
              load()
            }
          "
    >
      <template v-slot:action_tools>
        <v-btn v-if="isCan('log.download')" class="mx-2" dark depressed color="primary" @click="onDownload">
          <v-icon small left>mdi-download</v-icon>
          Unduh
        </v-btn>
      </template>
      <template v-slot:action_ext>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" class="rounded mx-3 pa-5 grey lighten-3" depressed small icon @click="dialog = true">
              <v-icon>mdi-filter</v-icon>
            </v-btn>
          </template>
          <span>Filter Log</span>
        </v-tooltip>
      </template>
      <template v-slot:items="{ props, item }">
        <tr>
          <td>
            {{ (item && item.organisasi && item.organisasi.nama) || '' }}
          </td>
          <td>
            <b>{{ pVal(item, 'user', 'nama') }} </b><br />
            <small class="grey--text"> {{ pVal(item, 'user', 'email') }} </small>
          </td>
          <td>{{ pVal(item, 'updated_at') | toDT }}</td>
          <td><span v-html="item.modul" />
            <v-spacer></v-spacer>
            <m-button
              v-if="item.akses=='pengaturan.update'"
              fab
              x-small
              icon="mdi-magnify-plus"
              :large="false"
              color="primary"
              dark
              action="getDetail"
              @getDetail="getDetail(item)"
            ></m-button>
          </td>
        </tr>
      </template>
    </m-card-list>
    <v-dialog scrollable v-model="dialog" max-width="600">
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar flat color="primary">
            <v-toolbar-title class="white--text">
              Filter Berdasarkan
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="white" icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>
        </v-card-title>

        <v-card-text>
          <v-container class="black--text my-2">
            <v-row no-gutters dense>
              <v-col v-if="false" cols="12" md="12" sm="12">
                <v-select
                  v-model="filters.jenis_sim"
                  dense
                  outlined
                  single-line
                  :items="toMasters(masters.M_JENIS_SIM)"
                  placeholder="Jenis SIM"
                  label="Jenis SIM"
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-select
                  v-model="filters.peran"
                  dense
                  outlined
                  single-line
                  :items="toMasters(masters.M_PERAN_AKSES)"
                  placeholder="Peran Admin"
                  label="Peran Admin"
                >
                </v-select>
              </v-col>
              <v-col v-if="organisasi_id" cols="12" md="12" sm="12">
                <v-autocomplete
                  v-model="filters.user_id"
                  dense
                  outlined
                  single-line
                  :items="listUsers"
                  item-text="nama"
                  item-value="user_id"
                  placeholder="Cari User"
                  label="Username"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-row>
                  <v-col cols="12" md="12" sm="12" class="py-0">
                    <span class="primary--text"> Rentang Tanggal</span>
                  </v-col>
                  <v-col cols="12" md="6" sm="12">
                    <m-datepicker
                      v-model="filters.from"
                      dense
                      single-line
                      outlined
                      label="Tanggal Mulai"
                      hint="Tanggal Mulai"
                    ></m-datepicker>
                  </v-col>
                  <v-col cols="12" md="6" sm="12">
                    <m-datepicker
                      v-model="filters.to"
                      dense
                      single-line
                      outlined
                      label="Tanggal Akhir"
                      hint="Tanggal Akhir"
                      :min="filters.from"
                    ></m-datepicker>
                  </v-col>
                </v-row>
              </v-col>
              <v-col v-if="!organisasi_id" cols="12" md="12" sm="12">
                <v-autocomplete
                  v-model="filters.kode_organisasi"
                  dense
                  outlined
                  single-line
                  :items="listOrganisasi"
                  item-text="nama"
                  item-value="kode_organisasi"
                  placeholder="Cari Organisasi"
                  label="Instansi"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
          <v-divider class="my-2"></v-divider>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="orange" dark depressed @click="onReset"><v-icon left>mdi-autorenew</v-icon> Reset</v-btn>
          <v-btn color="primary" depressed @click="onFilter"><v-icon left>mdi-check</v-icon> Terapkan</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <DetailLog ref="detailLog"/>
  </v-container>
</template>

<script>
import MASTERS from '../const'
import DetailLog from '../components/DetailLog.vue'

export default {
  components: {
    DetailLog
  },
  data() {
    return {
      items: [],
      textSearch: null,
      page: null,
      cp: 1,
      dialog: false,
      headers: [
        { text: 'Instansi', align: 'left', value: 'organisasi', sortable: false },
        { text: 'Username', align: 'left', value: 'username', sortable: false },
        { text: 'Tgl Akses', align: 'left', value: 'updated_at', sortable: false },
        { text: 'Modul Akses', align: 'left', value: 'modul', sortable: false },
      ],
      filters: {},
      masters: MASTERS,
      listOrganisasi: [],
      listUsers: [],
    }
  },
  computed: {},
  activated() {
    this.load()
    if (this.organisasi_id) this.loadUsers()
    if (!this.organisasi_id) this.loadOrganisasi()
  },
  methods: {
    toMasters(items = {}) {
      let result = []
      Object.keys(items).forEach((key) => {
        result.push({ value: key, text: items[key] })
      })
      return result
    },

    getDetail(item){
      this.$refs.detailLog.open(item)
    },

    load() {
      let deffParams = {}

      if (this.organisasi_id) {
        this.$set(deffParams, 'kode_organisasi', this.organisasi_id)
      }

      this.$store
        .dispatch(
          'log/get',
          Object.assign(
            { page: this.cp, keyword: this.textSearch, kode_tenant: this.tenant_id },
            this.filters,
            deffParams
          )
        )
        .then((res) => {
          this.page = res.data
          this.items = res.data.data
          this.dialog = false
        })
        .catch((e) => e)
    },

    loadOrganisasi() {
      if (!this.isCan('organisasi.index')) return
      this.$store.dispatch('organisasi/get', { count: 100 }).then(({ data }) => {
        this.listOrganisasi = (data && data.data) || []
        this.listOrganisasi.unshift({
          kode_organisasi: this.tenant_id,
          nama: 'Semua Organisasi',
        })
      })
    },

    loadUsers() {
      if (!this.isCan('user.index')) return
      this.$store
        .dispatch('user/get', {
          organisasi_id: this.organisasi_id,
          params: { keyword: (this.filters && this.filters.username) || '', count: 500 },
        })
        .then(({ data }) => {
          this.listUsers = data || []
        })
    },

    onFilter() {
      this.load()
    },

    onReset() {
      this.filters = {}
    },

    onDownload() {
      if (!this.filters.from || !this.filters.to) {
        this.$error('Harap memilih range tanggal terlebih dahulu')
        return
      }
      let deffParams = {}

      if (this.organisasi_id) {
        this.$set(deffParams, 'kode_organisasi', this.organisasi_id)
      }

      this.$store
        .dispatch(
          'log/download',
          Object.assign({ keyword: this.textSearch, kode_tenant: this.tenant_id }, this.filters, deffParams)
        )
        .then((url) => {
          window.open(url, '_blank')
        })
    },
  },
}
</script>
